module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "y-popover"
  }, [_c('y-tooltips', {
    attrs: {
      "theme": "white y-popover",
      "trigger": _vm.trigger,
      "placement": _vm.placement
    }
  }, [_c('template', {
    slot: "slot"
  }, [_vm._t("slot")], 2), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "y-tooltips-title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "y-tooltips-content"
  }, [_vm._t("content")], 2)])], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-38f24789!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/popover/popover.vue
// module id = 464
// module chunks = 27